import { ZONE, type Zone } from '../config/constants';
import { getZoneBands } from '../setup/zoneBands';

export type { Zone };

/**
 * Map impact Y (meters above pell base) to zone, given total pell height (m).
 * Out-of-range Y returns null. Uses the user-tunable zone bands (see `zoneBands`).
 */
export function zoneFromImpactY(yMeters: number, pellHeightM: number): Zone | null {
  if (!isFinite(yMeters) || !isFinite(pellHeightM) || pellHeightM <= 0) return null;
  if (yMeters < 0 || yMeters > pellHeightM) return null;
  const frac = yMeters / pellHeightM;
  const bounds = getZoneBands();
  if (frac >= bounds.head[0]) return ZONE.head;
  if (frac >= bounds.shoulder[0]) return ZONE.shoulder;
  if (frac >= bounds.chest[0]) return ZONE.chest;
  if (frac >= bounds.flank[0]) return ZONE.flank;
  return ZONE.leg;
}
